import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FilterGenerationComponent } from './filter-generation.component';
import { FilterPreviewItemComponent } from './filter-previewitem/filter-previewitem.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FilterCreateEditComponent } from './filter-create-edit/filter-create-edit.component';

@NgModule({
  declarations: [FilterGenerationComponent, FilterPreviewItemComponent, FilterCreateEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    TooltipModule,
    NgxJsonViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [FilterGenerationComponent],
})
export class FilterGenerationModule {}
